// extracted by mini-css-extract-plugin
var _1 = "ImageElement_fallback__dac92";
export { _1 as "fallback" }
